import { render, staticRenderFns } from "./CompositionApiExampleComponent.vue?vue&type=template&id=5dff535d&"
import script from "./CompositionApiExampleComponent.vue?vue&type=script&lang=js&"
export * from "./CompositionApiExampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports